import React from 'react';
import { ErrorBoundary } from '../ui/ErrorBoundary';

// App-wide safety net: a thrown render error in any page used to blank the
// ENTIRE console (white screen, no recovery). This contains the blast radius
// to the main content area and offers a recover action. `resetKey` (the active
// nav id) auto-clears the error when the user navigates elsewhere.
// The boundary and its fallback are ui/ErrorBoundary (merged with the venue module's kit, whose
// boundary also takes reset keys, an inline size for one failing panel, and a custom fallback).
export const PageErrorBoundary = ({ resetKey, children }) => (
  <ErrorBoundary resetKeys={[resetKey]} title="This section hit an error"
    description="The rest of the console is fine. Switch to another surface, or reload. The error has been logged to the browser console.">
    {children}
  </ErrorBoundary>
);
